import graphql__29e35b16f17349943ea7 from "./__generated__/ContainerWithSidebar_sidebar.graphql.js";import { useEffect, useState } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import Sidebar from "./Sidebar";
import { handleImagesLoading } from "../Utils/handleImagesLoading";

const SIDEBAR_POSITION_FIRST = "sidebar_first";
const SIDEBAR_POSITION_LAST = "sidebar_last";

const ContainerWithSidebar = ({
  columnsRatio = "2_1",
  columnsOrder = SIDEBAR_POSITION_LAST,
  ...props
}) => {
  const sidebar = useFragment(ContainerWithSidebar_sidebar, props.sidebar);
  const { children } = props;
  const hasSidebar = sidebar?.hasSections;

  const [sidebarNode, setSidebarNode] = useState();

  useEffect(() => {
    if (!sidebarNode) return;

    // Ensure that a "resize" event is triggered once each image is loaded
    handleImagesLoading(sidebarNode);
  }, [sidebarNode]);

  // If the sidebar is missing or there's no content in the sidebar, just render the
  // component's children and avoid displaying an empty sidebar
  if (!hasSidebar) return children;

  const isSidebarFirst = columnsOrder === SIDEBAR_POSITION_FIRST;
  const isSidebarLast = !isSidebarFirst;

  const className = classNames([
    "row",
    "container-with-sidebar",
    `columns-ratio-${columnsRatio}`,
    {
      "sidebar-first": isSidebarFirst,
      "sidebar-last": isSidebarLast
    }
  ]);

  const mainContent = (
    <div className="two-cols-left-bar d-flex flex-column">{children}</div>
  );

  return (
    <div className={className}>
      {isSidebarLast && mainContent}

      <div className="two-cols-right-bar d-flex flex-column" ref={setSidebarNode}>
        <Sidebar sidebar={sidebar} />
      </div>

      {isSidebarFirst && mainContent}
    </div>
  );
};

const ContainerWithSidebar_sidebar = graphql__29e35b16f17349943ea7;

export default ContainerWithSidebar;
